<template>
  <div class="columns is-multiline is-relative" v-for="chunkIndex in [0, 1]" :key="chunkIndex" ref="index">
    <div class="divider centering w-80 has-background-theme-blue is-hidden-mobile" :style="(chunkIndex === 1) ? {top:'60%'}: {top:'55%'}"></div>

    <template v-for="(item, index) in contents[chunkIndex]" :key="index">
      <div class="column is-3" :class="chunkIndex === 1 ? 'mt-6 pt-3': ''">
        <figure class="image is-64x64 m-auto">
          <img class="object-fit-contain" :src="item.step_src" :alt="item.alt">
        </figure>
        <figure class="image is-256x256 m-auto is-hidden-mobile w-70">
          <img class="object-fit-contain" :src="item.icon_src" :alt="item.alt">
        </figure>
        <figure class="image is-256x256 m-auto is-hidden-tablet w-40">
          <img class="is-rounded" :src="item.icon_src" :alt="item.alt">
        </figure>
        <p class="has-text-centered title is-5 mt-3" v-html="item.comment"></p>
        <p class="has-text-centered" v-html="item.number"></p>
      </div>

    </template>
  </div>
  <p class="is-size-7 has-text-theme-green ml-6"><span class="number-count mr-2">○回目</span>書類提出タイミング</p>
  <p class="is-size-7 ml-6 has-text-weight-bold mt-4">※当選となった場合、当選した施設様のみご提出頂きます。</p>
  <p class="is-5 has-text-centered attention-wrap">ご発注後、保育施設様から大阪府に提出する各種補助事業申請書類の対応については、<br><span class="attention-text mr-1">弊社が丁寧にサポート</span>させて頂きます。</p>

  <!-- <p class="is-size-7 mt-5">
    ・申請書類提出（書類提出:1回目）について<br>
【補助事業を使う意思】を大阪府に伝えるものです。どこの施設が、何をどれくらい購入するか、その金額はいくらなのか・・・等です。</p> -->
  <!-- <p class="is-size-7 mt-1">
    ・交付申請書類提出（書類提出:2回目）について<br>
1回目に提出した【申請書類】が受理され、補助事業が交付される事が決まったら提出する書類です。これが受理されると、子育て施設様に交付決定通知書が届きます。</p>
  <p class="is-size-7 mt-1">
    ・完了書類提出（書類提出:3回目）について<br>
  納品・設置が完了したら提出する書類です。これが最後の提出書類です。</p>
  <p class="is-size-7 mt-1">
    ・現地調査について<br>
  大阪府の職員さんが訪問し、現地の調査を行います。</p> -->
</template>

<script>
import chunk from 'lodash/chunk';

const CONTENTS = [
  {
    "step": "01",
    "icon_src": "./static_img/icon01.png",
    "step_src": "./static_img/01.png",
    "alt": "問い合わせ",
    "comment": "問い合わせ"
  },
  {
    "step": "02",
    "icon_src": "./static_img/icon02.png",
    "step_src": "./static_img/02.png",
    "alt": "ヒアリング（オンライン対応可）",
    "comment": "ヒアリング<br>（オンライン対応可）"
  },
  {
    "step": "03",
    "icon_src": "./static_img/icon04.png",
    "step_src": "./static_img/03.png",
    "alt": "商品決定/書類提出",
    "comment": "商品決定/書類提出",
    "number": '<span class="number-count mr-2">1回目</span>'
  },
  {
    "step": "04",
    "icon_src": "./static_img/icon07.png",
    "step_src": "./static_img/04.png",
    "alt": "書類提出",
    "comment": '書類提出<span class="is-size-7">※</span>',
    "number": '<span class="number-count">2回目</span>'
  },
  {
    "step": "05",
    "icon_src": "./static_img/icon05.png",
    "step_src": "./static_img/05.png",
    "alt": "発注",
    "comment": "発注"
  },
  {
    "step": "06",
    "icon_src": "./static_img/icon06.png",
    "step_src": "./static_img/06.png",
    "alt": "納品",
    "comment": "納品"
  },
  {
    "step": "07",
    "icon_src": "./static_img/icon07.png",
    "step_src": "./static_img/07.png",
    "alt": "書類提出",
    "comment": "書類提出",
    "number": '<span class="number-count">3回目</span>'
  },
  {
    "step": "08",
    "icon_src": "./static_img/icon08.png",
    "step_src": "./static_img/08.png",
    "alt": "現地調査（大阪府職員）",
    "comment": "現地調査<br>（大阪府職員）"
  },
];

export default {
  name: 'parts-flow',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    contents() {
      return chunk(CONTENTS, 4);
    }
  }
}
</script>

<style scoped>
.divider {
  height: 2px;
}
.attention-wrap {
  background-color: #fff;
  padding: 15px;
  line-height: 2.5;
  font-weight: bold;
  margin-top: 50px;
}
.attention-text {
  background: #333;
  color: #fff;
  padding: 0.5em;
}
</style>

<style>
.number-count {
  background: #29B35D;
  padding: 6px 8px;
  /* margin-right: 8px; */
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}

</style>
